import { add_vueApp2 } from '../../packs/vue_helper'

import StudentsStats from "./students-stats.vue";
import PagePayments from "./page-payments.vue";
import PageTopsellers from "./page-topsellers.vue";
import PageSubscriptions from "./page-subscriptions.vue";

import PageLessons from "./page-lessons.vue";
import Dashboard from "./dashboard.vue";
import GlobalReporting from "./global-reporting.vue";
import PageCzeReg from "./page-cze-reg.vue";
import axios from "axios";

document.addEventListener('DOMContentLoaded', () => {
    const csfr_token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csfr_token;
    axios.defaults.withCredentials=true


    add_vueApp2('app-students-statistics', StudentsStats)
    add_vueApp2('app-stats-payments', PagePayments)
    add_vueApp2('app-stats-topsellers', PageTopsellers)
    add_vueApp2('app-stats-subscriptions', PageSubscriptions)
    add_vueApp2('app-stats-lessons', PageLessons)
    add_vueApp2('app-stats-dashboard', Dashboard)
    add_vueApp2('app-global-reporting', GlobalReporting)
    add_vueApp2('app-stats-cze-reg', PageCzeReg)
})
